import { useState } from "react";
import { MYPAGE_DATA_LIMIT } from "../../../../utils/config";
import { Link } from "react-router-dom";
import MypagePagination from "../common/MypagePagination";
import { APPLIED_COURSE } from "../../../../utils/config";

const CourseDataTable = ({
  displayType,
  tableData,
  acquisitionUnitSum = null,
  currentPage,
  setCurrentPage,
}) => {
  // 1ページの件数
  const [limit] = useState(MYPAGE_DATA_LIMIT);

  // 1ページに表示するデータ
  let dispData = tableData;
  // 表示開始件数
  const offset = (currentPage - 1) * limit;
  dispData = dispData.slice(offset, offset + Number(limit));

  // 申込済み講座
  const AppliedCourse = 1;

  // 講座の公開状態（非公開）
  const StatusUnpublish = "非公開";

  return (
    <>
      {displayType === AppliedCourse ? (
        <>
          <h2 className="p-user-ttl">申込済みの講座</h2>
          <p className="p-course-resutl__txt01">
            ※一部の講座については、申込期間終了後のキャンセルはできません。
          </p>
        </>
      ) : (
        <>
          <h2 className="p-user-ttl">これまで受講した講座</h2>
          <div className="p-course-result__box">
            <p className="p-course-result__txt02">
              取得単位合計数：{acquisitionUnitSum}
            </p>
          </div>
        </>
      )}
      <div className="p-course-tbl__wrap">
        <>
          {displayType === AppliedCourse ? (
            <table>
              <tbody>
                <tr>
                  <th className="w-25">講座名</th>
                  <th className="w-15">実施機関</th>
                  <th className="w-15">開催日</th>
                  <th className="w-20">申込期間</th>
                  <th className="w-10">当選状況</th>
                  <th className="w-15">キャンセル申込</th>
                </tr>
                {dispData.map((rData) => {
                  return (
                    <tr key={rData.course_id}>
                      <td>
                        <Link to={"/mypage/course/detail/" + rData.course_id}>
                          {rData.course_name.replace(/　/g, " ")}
                        </Link>
                      </td>
                      <td>{rData.organ}</td>
                      <td>{rData.period}</td>
                      <td>
                        {rData.period_f}～{rData.period_t}
                      </td>
                      <td>{rData.lottery_status}</td>
                      <td>
                        {rData.is_cancelable ? (
                          <Link
                            to={"/mypage/course/cancel/" + rData.course_id}
                            state={{ prev: APPLIED_COURSE }}
                          >
                            キャンセルしたい場合はこちら
                          </Link>
                        ) : (
                          <></>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <table>
              <tbody>
                <tr>
                  <th className="w-20">講座名</th>
                  <th className="w-20">実施機関</th>
                  <th className="w-20">開催日</th>
                  <th className="w-20">取得単位数</th>
                  <th className="w-20">備考 1回出席あたり単位数</th>
                </tr>
                {dispData.map((rData) => {
                  return (
                    <tr key={rData.course_id}>
                      <td>
                        {rData.status === StatusUnpublish ? (
                          <>{rData.course_name.replace(/　/g, " ")}</>
                        ) : (
                          <Link to={"/mypage/course/detail/" + rData.course_id}>
                            {rData.course_name.replace(/　/g, " ")}
                          </Link>
                        )}
                      </td>
                      <td>{rData.organ}</td>
                      <td>{rData.period}</td>
                      <td>{rData.acquisition_unit}</td>
                      <td>{rData.course_acquisition_unit}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </>
      </div>
      {
        <MypagePagination
          tableData={tableData}
          limit={limit}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      }
    </>
  );
};

export default CourseDataTable;
